module.exports = __webpack_public_path__ + "static/media/AltaEficiencia.f921bed0.png";